import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class WalletSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (success) {
      return {
        statusCode: 200,
        success: true,
        message: 'ok',
        data: {
          balance: serverRes.data?.currentBalance || 0
        }
      };
    }
    return {
      statusCode: serverRes.statusCode || raw.status || 500,
      success: false,
      message:
        (serverRes.message || 'Erreur lors de la récupération') +
        ` Code d'erreur: TRX_ERR_${
          serverRes.statusCode || raw.status || '1000'
        }`,
      data: null
    };
  }

  serialize() {}
}

export const serializer = new WalletSerializer();
